import { render, staticRenderFns } from "./CommunityCategoryTags.vue?vue&type=template&id=5ab37dfc&scoped=true"
import script from "./CommunityCategoryTags.vue?vue&type=script&lang=js"
export * from "./CommunityCategoryTags.vue?vue&type=script&lang=js"
import style0 from "./CommunityCategoryTags.vue?vue&type=style&index=0&id=5ab37dfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab37dfc",
  null
  
)

export default component.exports